import React, {useEffect, useState} from "react";
import {createTheme, FormControl, MenuItem, Select, ThemeProvider} from "@mui/material";
import {styled} from "@mui/system";

import {useTimezone} from "../../hooks/useTimezone";
import {customBackOfficeTheme} from "../themes/customBackOfficeTheme";

export default function TimezoneOption() {
    const {timezone, updateTimezone, timezoneStore} = useTimezone();
    const [selectableTimezones, setSelectableTimezones] = useState([]);

    const TimezoneDropdown = styled(Select)(({theme}) => ({
        color: 'white',
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent'
    }}));

    useEffect(() => {
        const selectableTimezones = timezoneStore.getSelectableTimezones();

        sortTimezones(selectableTimezones);
        setSelectableTimezones(selectableTimezones);
    }, []);

    const sortTimezones = (timezones) =>
        timezones.sort((a, b) => {
            const aOffset = a.timezone.utcOffset();
            const bOffset = b.timezone.utcOffset();
            return aOffset - bOffset;
        });

    const onTimezoneUpdate = (event) => updateTimezone(event.target.value);

    const whiteSelectTheme = createTheme(customBackOfficeTheme, {
        components: {
            MuiSelect: {
                styleOverrides: {
                    root: {
                        color: 'white',
                        '& .MuiSelect-icon': {color: 'white'},
                        '&:hover:not(.Mui-disabled), &.Mui-focused': {borderColor: 'white'},
                        '&.Mui-focused .MuiSelect-icon': {color: 'white'},
                        '& fieldset': {borderColor: 'transparent'},
                        '&:hover:not(.Mui-disabled) fieldset': {borderColor: 'transparent'}
                    },
                },
            },
        },
    });

    return <>
        <ThemeProvider theme={whiteSelectTheme}>
            <FormControl size="small" sx={{marginRight: '-0.75rem'}}>
                <TimezoneDropdown
                    id="timeline-timezone-select"
                    value={timezone}
                    onChange={onTimezoneUpdate}>
                    {
                        selectableTimezones.map(timezoneOption => {

                            const offset = timezoneOption.timezone.format("Z");
                            const zone = timezoneOption.timezone.tz();
                            const city = zone.includes("/") ? zone.split("/").slice(-1)[0].replace("_", " ") : zone.replace("_", " ");
                            const label = `${city} (UTC ${offset})${timezoneOption.isLocal ? ' *' : ''}`;

                            return <MenuItem key={timezoneOption.timezone.tz()} value={timezoneOption.timezone.tz()}>{label}</MenuItem>;
                        })
                    }
                </TimezoneDropdown>
            </FormControl>
        </ThemeProvider>
    </>;
};
